import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import Swal from 'sweetalert2';
import Sidebar from '../../Sidebar';
import ReactTableWrapper from '../../components/ReactTableWrapper';
import ListFormPageHeader from '../../components/ListFormPageHeader';
import { displayError } from '../../helpers';
import {
    deletePurchaseInvoice,
    getAllPurchaseInvoices,
} from '../../services/PurchaseInvoiceServices';

function PurchaseInvoiceTable() {
    const [cookies] = useCookies(['myToken']);
    const navigate = useNavigate();
    const [data, setData] = useState({ total_pages: 0, records: [] });
    const [isLoading, setIsLoading] = useState(true);
    const [refreshKey, setRefreshKey] = useState(0);

    useEffect(() => {
        setIsLoading(true);
        getAllPurchaseInvoices(cookies)
            .then((response) => {
                setData({
                    total_pages: 1,
                    records: response.purchase_invoice_list || [],
                });
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                displayError(error.response?.data ?? error.message, 'Failed to load purchase invoices');
            });
    }, [cookies, refreshKey]);

    const columns = useMemo(() => ([
        { fieldName: 'invoice_no', headerName: 'Invoice No' },
        { fieldName: 'invoice_date', headerName: 'Invoice Date' },
        { fieldName: 'vendor_name', headerName: 'Vendor' },
        { fieldName: 'plant', headerName: 'Plant' },
        { fieldName: 'invoice_mode', headerName: 'Mode' },
        { fieldName: 'invoice_qty', headerName: 'Qty' },
        { fieldName: 'invoice_amt', headerName: 'Amount' },
        { fieldName: 'status', headerName: 'Status' },
        { fieldName: 'id', headerName: 'ROW_ACTIONS' },
    ]), []);

    const onEdit = (invoiceId) => navigate(`/PurchaseInvoiceEdit/${invoiceId}`);

    const onDelete = (invoiceId) => {
        Swal.fire({
            title: 'Delete this purchase invoice?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
        }).then((result) => {
            if (!result.isConfirmed) {
                return;
            }
            deletePurchaseInvoice(cookies, invoiceId)
                .then(() => {
                    Swal.fire('Deleted!', '', 'success');
                    setRefreshKey((k) => k + 1);
                })
                .catch((error) => displayError(error.response?.data ?? error.message, 'Delete Failed'));
        });
    };

    return (
        <>
            <div id="outer-container" className="App">
                <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
                <div id="page-wrap">
                    <ListFormPageHeader
                        module="PURCHASE"
                        title="Purchase Invoice"
                        subtitle="Browse purchase invoices created with or without GRN."
                        formLink="/PurchaseInvoice"
                        addNewLabel="New Purchase Invoice"
                    />
                    <div className="container item-list-table-container">
                        <ReactTableWrapper
                            title="Purchase Invoices"
                            columns={columns}
                            data={data.records}
                            onRowEdit={onEdit}
                            onRowDelete={onDelete}
                            isLoading={isLoading}
                            hideDelete={false}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default PurchaseInvoiceTable;
